import { Instant } from "@js-joda/core";
import ProductTemplateColumnsDropdown from "components/basic/dropdowns/product-template-columns-dropdown/ProductTemplateColumnsDropdown";
import {
  IProductTemplateDropdownChangeEvent,
  ProductTemplateDropdown,
} from "components/basic/dropdowns/product-template/ProductTemplateDropdown";
import { DatasetChartProps, LineEditorLoadingTypes } from "components/dashboard/charts/interfaces";
import { DropdownChangeEvent } from "primereact/dropdown";
import { MultiSelectChangeEvent } from "primereact/multiselect";
import React from "react";
import { T } from "services/lang/LanguageService";

interface ProductTemplateColumnsSelectionProps {
  currentConfig: DatasetChartProps;
  handleProductEntryIdChange: (e: IProductTemplateDropdownChangeEvent) => void;
  handleProductEntryColumnsChange: (e: MultiSelectChangeEvent | DropdownChangeEvent) => void;
  setProductTemplateCreationDate?: (date: Instant) => void;
}

export default function ProductTemplateColumnsSelection({
  currentConfig,
  handleProductEntryIdChange,
  handleProductEntryColumnsChange,
  setProductTemplateCreationDate,
}: ProductTemplateColumnsSelectionProps) {
  return (
    currentConfig.loadConf?.type === LineEditorLoadingTypes.PRODUCT_ENTRY && (
      <div className="flex flex-column md:flex-row justify-content-between ml-2 gap-3">
        <div className="flex flex-column gap-2 w-full md:w-6">
          <label htmlFor="productTemplateId">{T("load-conf.product-template")}</label>
          <ProductTemplateDropdown
            value={parseInt(currentConfig.loadConf.productTemplateId, 10)}
            onChange={handleProductEntryIdChange}
          />
        </div>
        <div className="flex flex-column gap-3 w-full md:w-6">
          <div className="flex flex-column gap-2">
            <label htmlFor="startAttribute">{T("load-conf.start-attribute")}</label>
            <ProductTemplateColumnsDropdown
              id="startAttribute"
              value={currentConfig.loadConf.startAttribute ? [currentConfig.loadConf.startAttribute] : []}
              onChange={handleProductEntryColumnsChange}
              selectedTemplate={{
                refName: currentConfig.loadConf.refName ?? "",
                value: parseInt(currentConfig.loadConf.productTemplateId, 10),
              }}
              showClear={false}
              setProductTemplateCreationDate={setProductTemplateCreationDate}
            />
          </div>
          <div className="flex flex-column gap-2">
            <label htmlFor="endAttribute">{T("load-conf.end-attribute")}</label>
            <ProductTemplateColumnsDropdown
              id="endAttribute"
              value={currentConfig?.loadConf.endAttribute ? [currentConfig.loadConf.endAttribute] : []}
              onChange={handleProductEntryColumnsChange}
              selectedTemplate={{
                refName: currentConfig.loadConf.refName ?? "",
                value: parseInt(currentConfig.loadConf.productTemplateId, 10),
              }}
              showClear={false}
              setProductTemplateCreationDate={setProductTemplateCreationDate}
            />
          </div>
        </div>
      </div>
    )
  );
}
